import store from '@/stores/store';
import {ModuleDbOption} from '@/stores/moduleConst';

export const useReadNumber = () => {

  const dbOptions = store.state[ModuleDbOption]?.dbOptions;

  /**
   * Xử lý đọc số
   */
  const numberText = input => {
    if (input == 0) {
      return '';
    } else {
      let readNumber = input || 0;
      let isNegative = readNumber < 0;
      let readText = read((isNegative ? -readNumber : readNumber).toString());
      let result;
      if (isNegative) {
        result = 'Âm ' + readText;
      } else {
        result = readText.charAt(0).toUpperCase() + readText.slice(1);
      }
      if (result != null) {
        result = result.trim();
      }
      if (result == '') {
        result += 'Không';
      }
      result += ` đồng`;
      if (dbOptions.SayMoney_Even) {
        result += ' chẵn';
      }
      return (dbOptions.SayMoney_Prefix || '') + result + (dbOptions.SayMoney_Surfix || '');
    }
  };

  const read = num => {
    // Đọc từng phần
    const output = [];

    let groupLength = num.length % 3;

    num = num.split('');
    for (let i = 0; i < 3 - groupLength && groupLength != 0; i++) {
      num.unshift('0');
    }
    num = num.join('');

    for (let i = 0; i < num.length / 3; i++) {
      let [a, b, c] = num.substr(i * 3, 3);
      a = parseInt(a);
      b = parseInt(b);
      c = parseInt(c);

      // Sửa lại ở đây
      const isFirstGroup = i == 0;
      // Nếu là rỗng thì sang bộ 3 tiếp theo
      if (a == 0 && b == 0 && c == 0) {
        continue;
      }

      output.push(...readThree(a, b, c, !isFirstGroup)); // Dùng spread operator

      // Đọc phần đơn vị của nhóm
      output.push(`${genUnits(num.length / 3 - 1 - i)}`);
    }
    return output.join(' ');
  };

  /**
   * giá trị đơn vị
   */
  const genUnits = index => {
    switch (index) {
      case 0:
        return '';
      default:
        let modIndex = index % 3;
        let res = '';
        switch (modIndex) {
          case 0:
            res = 'tỷ';
            break;
          case 1:
            res = `${dbOptions.SayMoney_Nghin || 'nghìn'}`;
            break;
          case 2:
            res = 'triệu';
            break;
        }
        if (dbOptions.SayMoney_ShowThousandSymbol) {
          res += ',';
        }
        return res || '';
    }
  };

  /**
   * Giá trị phần số
   */
  const genDigits = number => {
    switch (number) {
      case 0:
        return 'không';
      case 1:
        return 'một';
      case 2:
        return 'hai';
      case 3:
        return 'ba';
      case 4:
        return 'bốn';
      case 5:
        return 'năm';
      case 6:
        return 'sáu';
      case 7:
        return dbOptions.SayMoney_7 || 'bảy';
      case 8:
        return 'tám';
      case 9:
        return 'chín';
    }
  };

  // Định nghĩa function đọc hai số cuối
  function readTwo(b, c, hasHundred) {
    const output = [];

    switch (b) {
      case 0: {
        // Nếu có đọc hàng trăm (đọc rồi) và b = 0, c = 0
        // thì không đọc nữa
        if (hasHundred && c == 0) break;
        if (hasHundred) output.push(dbOptions.SayMoney_Linh); // ví dụ a05 đọc là "a lẻ năm"
        output.push(genDigits(c));
        break;
      }

      case 1: {
        // Trường hợp số hàng chục là 10
        output.push('mười');
        if (c == 5) output.push('lăm'); // Mười lăm
        else if (c != 0) output.push(genDigits(c));
        // Trường hợp c = 0 không xét vì đã đọc "mười" rồi
        break;
      }

      default: {
        output.push(genDigits(b), dbOptions.SayMoney_Muoi); // b mươi
        if (c == 1) output.push('mốt');
        // Chỗ này đọc "tư" hay "bốn" thì các bạn điều chỉnh nhe
        // Mình sẽ luôn đọc là "tư" nhé
        else if (c == 4) output.push(dbOptions.SayMoney_4);
        else if (c == 5) output.push('lăm');
        else if (c != 0) output.push(genDigits(c));
        // Không đọc c = 0 vì đã đọc "b mươi" rồi
        break;
      }
    }

    // Trả về mảng output, xem lại phần trước nhé
    return output;
  }

  // Định nghĩa function đọc 3 số
  function readThree(a, b, c, readZeroHundred) {
    const output = [];

    // Đọc phần trăm (a) trước
    if (a != 0 || readZeroHundred) output.push(genDigits(a), 'trăm'); // Đọc là "a trăm"

    // Nối thêm phần sau (b, c)
    // Ở đây dùng spread syntax để nối output
    output.push(...readTwo(b, c, a != 0 || readZeroHundred));

    return output;
  }

  return {numberText};
}


